import React, { ReactElement, useEffect } from 'react';
import { Nullable } from 'src/types/nullable.type';
import { Block } from '../types';
import { AddRecordingControlPanelContent } from './add-recording-control-panel-content';
import { useRecordingStore } from './store';
import { useEditorStore } from '../editor-store';
import { useBlockActions } from '../helpers/actions/use-block-actions.hook';

type Props = {
  block: Block;
  render: (title: string, subtitle: Nullable<string>, content: React.ReactNode) => ReactElement;
  onDeleteBlock: () => void;
}

export const AddRecordingControlPanel = ({
  block,
  render,
  onDeleteBlock,
}: Props) => {
  const recording = useRecordingStore((state: any) => state.recording);
  const started =  useRecordingStore((state: any) => state.started);
  const initiateCameraRecorder = useRecordingStore((state: any) => state.initiateCameraRecorder);
  const stopStream = useRecordingStore((state: any) => state.stopStream);
  const setOnComplete = useRecordingStore((state: any) => state.setOnComplete);
  const selectedBlockId = useEditorStore((state) => state.selectedBlockId);
  const { onNewFile } = useBlockActions(block);


  const onNativeRecordingComplete = async (file: File, duration?: number) => {
    onNewFile(file);
    stopStream();
  };

  useEffect(() => {
    if (recording  || started) return;
    if (selectedBlockId === block.id) {
      console.log("initiating camera again");
      initiateCameraRecorder();
      setOnComplete(onNativeRecordingComplete);
    }
  }, [recording, started, selectedBlockId, block.id]);
  
  if (recording || started) return null;

  return render('Add recording', null, <AddRecordingControlPanelContent block={block} onDeleteBlock={onDeleteBlock} />);
}